export default {
    SUBSCRIPTION_DETAILS_REQUEST: 'APP/SUBSCRIPTION_DETAILS/SUBSCRIPTION_DETAILS_REQUEST',
    SUBSCRIPTION_DETAILS_SUCCESS: 'APP/SUBSCRIPTION_DETAILS/SUBSCRIPTION_DETAILS_SUCCESS',
    SUBSCRIPTION_DETAILS_ERROR: 'APP/SUBSCRIPTION_DETAILS/SUBSCRIPTION_DETAILS_ERROR',
  };
  